module.exports = __webpack_public_path__ + "static/media/statusRegister.57f4d4c4.svg";